import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { makeResetCache, makeCompoundPayload, fetchApi, notifyResponse, notifyError } from 'gossamer-front-end';

export interface DeleteButtonProps {
  entityId: string;
  keyValue: string;
  followOnUrl: string;
  otherEntitiesToReset?: string[];
}

export const DeleteButton = (props: DeleteButtonProps): React.JSX.Element => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const resetCache = makeResetCache(dispatch);
  const isProcessing = React.useRef(false);

  const handleDelete = async () => {
    const check = confirm('Are you sure? This action cannot be reversed.');
    if (!check) {
      return;
    }
    if (isProcessing.current) {
      return;
    }
    try {
      isProcessing.current = true;
      const payload = makeCompoundPayload('save');
      payload.rows.push({
        entityId: props.entityId,
        action: 'U',
        key: props.keyValue,
        data: {
          status: 'INACTIVE',
        },
      });

      const resp = await fetchApi('POST', `/main/~/${props.entityId}.DeleteButton`, payload);
      resetCache(props.entityId);
      if (props.otherEntitiesToReset) {
        props.otherEntitiesToReset.forEach((entityId) => resetCache(entityId));
      }
      notifyResponse(resp);
      navigate(props.followOnUrl);
    } catch (e) {
      notifyError(e, 'An error occurred while deleting this record');
    }
    isProcessing.current = false;
  };

  return (
    <Button type="button" size="sm" variant="danger" onClick={handleDelete}>
      Delete
    </Button>
  );
};
